import { render, staticRenderFns } from "./cmdetzw.vue?vue&type=template&id=4ef2c72d&scoped=true&"
import script from "./cmdetzw.vue?vue&type=script&lang=js&"
export * from "./cmdetzw.vue?vue&type=script&lang=js&"
import style0 from "./cmdetzw.vue?vue&type=style&index=0&id=4ef2c72d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2c72d",
  null
  
)

export default component.exports